export default class Reports {
	static REPORT_RELOCATION = 141; // переселение в случае приглашения в дальнее королевство
	static REPORT_FARMLIST_RAID = 115;
	static REPORT_ADVENTURE = 21;
	static REPORT_WORLD_PEACE = '???';
	static REPORT_VACATION = '???';
}